export default "__VITE_ASSET__B1sNFa_P__"